__turbopack_context__.v({
  "animate": "spinning-loader-module-scss-module__2WUT-W__animate",
  "container": "spinning-loader-module-scss-module__2WUT-W__container",
});
